<section class="container position-relative" *ngIf="emailSearchForm">

        <div *ngIf="distributorInfo" class="distributorInformation text-right absolute-right">
                <div *ngIf="distributorInfo.name" class="bold header-font color-black distributor-name ">
                    {{distributorInfo | displayNameFormat}}
                </div>
                <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                    <span>{{distributorInfo.displayName | titlecase}}</span>
                  </div>
                <div class="font14">
                    <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
                    <span class="color-black" *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
                    <span *ngIf="distributorInfo.level"> | {{distributorInfo.level}}</span>
                </div>
        </div>

    <form [formGroup]="emailSearchForm" name="emailSearchForm" validate="true" (ngSubmit)="emailSearchForm.valid && emailLogSearch(emailSearchForm)">
        <div class="row">
            <div class="col-sm-3">
                <!-- {{emailSearchForm.controls['countryCode'].value | json}} -->
                <select class="form-control" formControlName="countryCode">
                    <option [value]="countries.homeCountryCode" *ngFor="let countries of storeCountries | orderBy:'name'; let i = index"
                        [selected]="countries.homeCountryCode === memberhomeCountryCode">
                        {{countries.name}}
                    </option>
                </select>
            </div>
            <div class="col-sm-3">
                <div class="floating-input floatLabelContainer">
                    <input type="text" class="form-control" float-label type="email" pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$" [maxlength]="50" placeholder="{{'email-view.Email' |translate | translateKey}}" formControlName="sentTo">
                    <div class="alert-msg" *ngIf="emailSearchForm.controls['sentTo'].hasError('pattern')">
                            {{'customer-service.Please enter a valid email address'|translate | translateKey}}
                        </div>     
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3">
                <div class="floating-input floatLabelContainer">
                    <input id="startDate" tabindex="0" [owlDateTime]="dt3" class="form-control"
                        placeholder="{{'customer-service.From Date dd-mmm-yyyy' |translate | translateKey}}"
                        formControlName="startDate" [max]="maxDate"  [isStartDateClicked]="true" (isStartDate)="convertStartDate($event)"
                        appRestrictSpecialCharacters maxlength="11" (dateTimeChange)="setMinDate()"
                        (blur)="emailLogTransformDate(emailSearchForm.controls['startDate'].value,true)" float-label
                        DateFormat>
                    <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt3></owl-date-time>
                    <span class="" [owlDateTimeTrigger]="dt3">
                        <span class="fa fa-calendar calendar-icon select-pointer"></span>
                    </span>
                    <div class="alert-msg"
                        *ngIf="!emailSearchForm.controls['startDate'].valid && !emailSearchForm.controls['startDate'].hasError('owlDateTimeMax') && (emailSearchForm.controls['startDate'].touched)">
                        {{'order.Enter valid Date'|translate | translateKey}}
                    </div>
                    <div class="alert-msg"
                        *ngIf="!emailSearchForm.controls['startDate'].valid && emailSearchForm.controls['startDate'].hasError('owlDateTimeMax') && (emailSearchForm.controls['startDate'].touched)">
                        {{'order.From Date should be less than Current Date'|translate | translateKey}}
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="floating-input floatLabelContainer">
                    <input id="endDate" tabindex="0" [owlDateTime]="dt4" class="form-control"
                        placeholder="{{'customer-service.To Date dd-mmm-yyyy' |translate | translateKey}}"
                        formControlName="endDate" [min]="minDate"
                        appRestrictSpecialCharacters maxlength="11" [isEndDateClicked]="true" (isEndDate)="convertEndDate($event)"
                        (blur)="emailLogTransformDate(emailSearchForm.controls['endDate'].value,false)" float-label
                        DateFormat>
                    <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt4></owl-date-time>
                    <span class="" [owlDateTimeTrigger]="dt4">
                        <span class="fa fa-calendar calendar-icon select-pointer"></span>
                    </span>
                    <div class="alert-msg"
                        *ngIf="!emailSearchForm.controls['endDate'].valid && !emailSearchForm.controls['endDate'].hasError('owlDateTimeMin') 
                        && (emailSearchForm.controls['endDate'].touched)">
                        {{'email-view.Enter valid Date'|translate | translateKey}}
                    </div>
                    <div class="alert-msg"
                        *ngIf="!emailSearchForm.controls['endDate'].valid && emailSearchForm.controls['endDate'].hasError('owlDateTimeMin') && (emailSearchForm.controls['endDate'].touched)">
                        {{'order.To Date should be less than From Date'|translate | translateKey}}
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <input type="text" class="form-control" placeholder="{{'email-view.Subject' |translate | translateKey}}" formControlName="subject">
            </div>
            <div class="col-sm-6 text-right">
                <button type="submit" [disabled]="!emailSearchForm.valid"                  
                class="btn blue-button">
                    {{'customer-service.Search' |translate | translateKey}}</button>
                <button (click)="clearFields()" type="button" class="btn grey-button">
                    {{'customer-service.Clear' |translate | translateKey}}</button>
            </div>
        </div>
    </form>


   
        <div class="mt-10">
                <select class="form-control select--xs" [formControl]="pageSizeCtrl" (change)=pagePerRecords(pageSizeCtrl.value)>
                    <option *ngFor="let page of pageRecords" [value]="page" [selected]="page === pageSize"> {{page}}
                    </option>
                </select>
            <span class="perpage-label">{{'email-view.Per Page' |translate | translateKey}}</span>
        </div>

   


    <div class="w-100">
        <div class="table-responsive mt-20 mb-20">
            <table class="table table-striped custab table-layout">
                <thead>
                    <tr>
                        <th class="wd-40">
                            {{'email-view.Subject' |translate | translateKey}}

                        </th>
                        <th class="wd-20">
                            {{'email-view.Send Date' |translate | translateKey}}

                        </th>
                        <th class="wd-20">{{'email-view.Send To' |translate | translateKey}}</th>
                        <th class="wd-10">{{'email-view.Country' |translate | translateKey}}</th>
                        <th class="wd-10">{{'email-view.Actions' |translate | translateKey}}</th>
                    </tr>
                </thead>
                <tbody class="white-space">
                    <tr *ngFor="let memberEmailLog of memberEmailLogs  | paginate: {  id: paginationId, itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount}">
                        <td><a class="pointerstyle"
                            (keyup.enter)="navigateToEmailDetils(memberEmailLog)"
                            (click)="navigateToEmailDetils(memberEmailLog)">
                            {{memberEmailLog.subject}}</a>
                        </td>
                        <td>{{memberEmailLog.sentDate}} </td>
                        <td>{{memberEmailLog.emailId}} </td>
                        <td>{{memberEmailLog.countryCode}} </td>
                        <td><a class="pointerstyle"
                                (keyup.enter)="navigateToEmailDetils(memberEmailLog)"
                                (click)="navigateToEmailDetils(memberEmailLog)">
                                <i class="fa fa-eye" title="{{'member-Email-Log.view' |translate |translateKey}}"></i></a>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!memberEmailLogs || memberEmailLogs?.length===0">
                    <tr>
                        <td colspan="5" class="text-center">
                            {{'email-view.No Records Found.' |translate |translateKey}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
        {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
        <pagination-controls id="{{paginationId}}" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
    </div>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-email-log.component.html